import { render } from "./database.vue?vue&type=template&id=3adda8d3&scoped=true"
import script from "./database.vue?vue&type=script&lang=js"
export * from "./database.vue?vue&type=script&lang=js"

import "./database.vue?vue&type=style&index=0&id=3adda8d3&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3adda8d3"]])

export default __exports__